<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="headline font-weight-bold mb-4">Indicadores Globales</div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-end align-center">
        <!------------------------------------------------------------------->
        <!-- RANGE-TIME OPTIONS --------------------------------------------->
        <!------------------------------------------------------------------->

        <v-btn-toggle
          mandatory
          color="primary"
          group
          dense
          class="elevation-3"
          style="background-color: white; border-radius: 12px"
        >
          <v-btn
            v-for="(option, i) in dateOptions"
            :key="i"
            class="ma-0 caption font-weight-medium"
            @click="defaultDateRange(option.start)"
          >
            {{ option.text }}
          </v-btn>
        </v-btn-toggle>

        <div
          class="elevation-3 mx-2"
          style="background-color: white; border-radius: 12px"
        >
          <v-menu offset-y full-width>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                text
                class="caption font-weight-medium grey--text text--darken-3"
              >
                {{ `${$t("dashboard.dates.from")} ${startDate}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="startDate"
              :locale="
                lang === 'es' ? 'es-mx' : lang === 'en' ? 'en-us' : 'pt-br'
              "
              no-title
              color="primary"
              :max="$moment().format('YYYY-MM-DD')"
            />
          </v-menu>
          <v-menu offset-y full-width>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                text
                class="caption font-weight-medium grey--text text--darken-3"
              >
                {{ `${$t("dashboard.dates.until")} ${endDate}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="endDate"
              :locale="
                lang === 'es' ? 'es-mx' : lang === 'en' ? 'en-us' : 'pt-br'
              "
              no-title
              color="primary"
              :max="$moment().format('YYYY-MM-DD')"
            />
          </v-menu>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <!------------------------------------------------------------------->
      <!-- TRANSACTIONS --------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="rounded-card"
          height="100%"
          style="background-color: white; border-radius: 12px"
        >
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
          >
            {{ $t("dashboard.transactions_success") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ transactions }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- TOTAL RENDERS -------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="rounded-card"
          height="100%"
          style="background-color: white; border-radius: 12px"
        >
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
          >
            {{ $t("dashboard.total_renders") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ totalRenders }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- TOTAL DONATIONS -------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="rounded-card"
          height="100%"
          style="background-color: white; border-radius: 12px"
        >
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
          >
            Total de Donaciones ($)
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ totalDonationAmount }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- TOTAL MAIL SENT -------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="rounded-card"
          height="100%"
          style="background-color: white; border-radius: 12px"
        >
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
          >
            Correos Enviados
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ totalEmailSent }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- TOTAL LEADS -------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="rounded-card"
          height="100%"
          style="background-color: white; border-radius: 12px"
        >
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
          >
            Total de Leads
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ totalLeads }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- TOTAL LANDINGS -------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="rounded-card"
          height="100%"
          style="background-color: white; border-radius: 12px"
        >
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
          >
            Total de Landings Activas
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ totalLandings }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <!------------------------------------------------------------------->
      <!-- TOTAL FORMS-------------------------------------------------->
      <!------------------------------------------------------------------->
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="rounded-card"
          height="100%"
          style="background-color: white; border-radius: 12px"
        >
          <v-card-title
            class="subtitle-1 font-weight-medium grey--text text--darken-2"
          >
            Total de Forms Activos
          </v-card-title>
          <v-divider />
          <v-card-text class="text-right">
            <span class="headline font-weight-medium primary--text">
              {{ totalForms }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card
        color="primary"
        dark
        style="background-color: white; border-radius: 12px"
      >
        <v-card-text>
          {{ $t("general.loading") }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "GlobalStats",
  watch: {
    startDate(newValue) {
      if (newValue > this.endDate) {
        this.$noty.error(this.$t("general.error.invalid_range"));
        return;
      }
      this.getData("filter");
    },
    endDate(newValue) {
      if (newValue < this.startDate) {
        this.$noty.error(this.$t("general.error.invalid_range"));
        return;
      }
      this.getData("filter");
    }
  },
  data() {
    return {
      isLoading: false,
      transactions: 0,
      totalRenders: 0,
      totalEmailSent: 0,
      totalDonationAmount: 0,
      totalLeads: 0,
      totalLandings: 0,
      totalForms: 0,
      startDate: this.$moment()
        .startOf("month")
        .startOf("day")
        .format("YYYY-MM-DD"),
      endDate: this.$moment().format("YYYY-MM-DD")
    };
  },
  computed: {
    ...mapState({
      creationDateOrg: ({ auth: { user } }) => user,
      lang: ({ auth: { locale } }) => locale,
      user: ({ auth: { user } }) => user
    }),
    ...mapGetters({
      globalStats: "dashboardClients/globalStats"
    }),
    dateOptions() {
      if (this.creationDateOrg.organization) {
        return [
          {
            text: this.$t("dashboard.dates.all"),
            value: "All",
            start: this.$moment(
              this.creationDateOrg.organization.created_at
            ).format("YYYY-MM-DD")
          },
          {
            text: "1w",
            value: "1w",
            start: this.$moment()
              .subtract(6, "days")
              .startOf("day")
              .format("YYYY-MM-DD")
          },
          {
            text: "4w",
            value: "4w",
            start: this.$moment()
              .subtract(1, "month")
              .add(1, "day")
              .startOf("day")
              .format("YYYY-MM-DD")
          },
          {
            text: "1y",
            value: "1y",
            start: this.$moment()
              .subtract(1, "year")
              .add(1, "day")
              .startOf("day")
              .format("YYYY-MM-DD")
          }
        ];
      }
      return "";
    }
  },
  async created() {
    this.getData();
    this.startDate = this.creationDateOrg.organization.created_at
      ? this.$moment(this.creationDateOrg.organization.created_at).format(
          "YYYY-MM-DD"
        )
      : this.$moment()
          .startOf("month")
          .startOf("day")
          .format("YYYY-MM-DD");
  },
  methods: {
    ...mapActions({
      getGlobalStats: "dashboardClients/getGlobalStats"
    }),
    async getData(type) {
      this.isLoading = true;
      if (type && type == "filter") {
        const startTime = this.startDate;
        const endTime = this.endDate;
        await this.getGlobalStats({
          type: "filter",
          startTime: startTime,
          endTime: endTime
        });
      } else {
        await this.getGlobalStats();
      }
      this.isLoading = false;
      const {
        total_amount_donation,
        total_donation,
        total_leads,
        total_renders,
        total_email_sent,
        total_landings,
        total_forms
      } = this.globalStats;

      const NumberFormat = new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "USD"
      });
      const totalDonationAmount = NumberFormat.format(total_amount_donation);

      this.transactions = total_donation;
      this.totalRenders = total_renders;
      this.totalEmailSent = total_email_sent;
      this.totalDonationAmount = totalDonationAmount;
      this.totalLeads = total_leads;
      this.totalLandings = total_landings;
      this.totalForms = total_forms;
    },
    defaultDateRange(start) {
      this.startDate = start;
      this.endDate = this.$moment().format("YYYY-MM-DD");
    }
  }
};
</script>
